import Vue from "vue";
import VueRouter from "vue-router";
// import Home from '../views/Home.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue")
  },

  {
    path: "/whats-on",
    name: "whats-on",
    component: () =>
      import(/* webpackChunkName: "whats-on" */ "../views/WhatsOn.vue")
  },

  {
    path: "/festivals",
    name: "festivals",
    component: () =>
      import(/* webpackChunkName: "festivals" */ "../views/Festivals.vue")
  },
  {
    path: "/preview-festival",
    name: "single-festival",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "single-festival" */ "../views/post/Festival.vue"
      )
  },
  {
    path: "/festival/:slug",
    name: "single-festival",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "single-festival" */ "../views/post/Festival.vue"
      )
  },
  {
    path: "/preview-exhibition",
    name: "single-exhibition",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "single-exhibition" */ "../views/post/Exhibition.vue"
      )
  },
  {
    path: "/exhibition/:slug",
    name: "single-exhibition",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "single-exhibition" */ "../views/post/Exhibition.vue"
      )
  },
  {
    path: "/preview-event",
    name: "single-event",
    props: true,
    component: () =>
      import(/* webpackChunkName: "single-event" */ "../views/post/Event.vue")
  },
  {
    path: "/event/:slug",
    name: "single-event",
    props: true,
    component: () =>
      import(/* webpackChunkName: "single-event" */ "../views/post/Event.vue")
  },

  {
    path: "/stories",
    name: "stories",
    props: true,
    component: () =>
      import(/* webpackChunkName: "stories" */ "../views/Stories.vue")
  },

  {
    path: "/press",
    name: "press",
    props: true,
    component: () =>
      import(/* webpackChunkName: "press" */ "../views/Press.vue")
  },
  {
    path: "/preview-press",
    name: "single-press",
    props: true,
    component: () =>
      import(/* webpackChunkName: "press" */ "../views/post/Press.vue")
  },
  {
    path: "/press/:slug",
    name: "single-press",
    props: true,
    component: () =>
      import(/* webpackChunkName: "press" */ "../views/post/Press.vue")
  },

  {
    path: "/cat/:slug",
    name: "stories",
    props: true,
    component: () =>
      import(/* webpackChunkName: "stories" */ "../views/Stories.vue")
  },

  {
    path: "/type/:slug",
    name: "type",
    props: true,
    component: () => import(/* webpackChunkName: "type" */ "../views/Type.vue")
  },
  {
    path: "/preview-stories",
    name: "single-stories",
    props: true,
    component: () =>
      import(/* webpackChunkName: "stories" */ "../views/post/Stories.vue")
  },
  {
    path: "/stories/:slug",
    name: "single-stories",
    props: true,
    component: () =>
      import(/* webpackChunkName: "stories" */ "../views/post/Stories.vue")
  },

  {
    path: "/in-focus",
    name: "objects",
    props: true,
    component: () =>
      import(/* webpackChunkName: "objects" */ "../views/Objects.vue")
  },

  {
    path: "/object-cat/:slug",
    name: "objects",
    props: true,
    component: () =>
      import(/* webpackChunkName: "objects" */ "../views/Objects.vue")
  },

  {
    path: "/preview-object",
    name: "single-object",
    props: true,
    component: () =>
      import(/* webpackChunkName: "object" */ "../views/post/Object.vue")
  },

  {
    path: "/object/:slug",
    name: "single-object",
    props: true,
    component: () =>
      import(/* webpackChunkName: "object" */ "../views/post/Object.vue")
  },

  {
    path: "/ideas",
    name: "ideas",
    props: true,
    component: () =>
      import(/* webpackChunkName: "ideas" */ "../views/Ideas.vue")
  },

  {
    path: "/podcasts",
    name: "podcasts",
    props: true,
    component: () =>
      import(/* webpackChunkName: "podcasts" */ "../views/Podcasts.vue")
  },

  {
    path: "/preview-podcasts",
    name: "single-podcast",
    props: true,
    component: () =>
      import(/* webpackChunkName: "podcast" */ "../views/post/Podcast.vue")
  },

  {
    path: "/podcast/:slug",
    name: "single-podcast",
    props: true,
    component: () =>
      import(/* webpackChunkName: "podcast" */ "../views/post/Podcast.vue")
  },

  {
    path: "/all-people",
    name: "peoples",
    props: true,
    component: () =>
      import(/* webpackChunkName: "peoples" */ "../views/Peoples.vue")
  },

  {
    path: "/preview-people",
    name: "single-people",
    props: true,
    component: () =>
      import(/* webpackChunkName: "people" */ "../views/post/People.vue")
  },

  {
    path: "/people/:slug",
    name: "single-people",
    props: true,
    component: () =>
      import(/* webpackChunkName: "people" */ "../views/post/People.vue")
  },

  {
    path: "/preview-page",
    name: "page",
    props: true,
    component: () => import(/* webpackChunkName: "page" */ "../views/Page.vue")
  },

  // {
  //   path: "/charleston-lewes:afterUser(.*)",
  //   name: "page",
  //   props: true,
  //   component: () =>
  //     import(/* webpackChunkName: "page" */ "../views/LandingPage.vue")
  // },

  // {
  //   path: "/winter-at-charleston:afterUser(.*)",
  //   name: "page",
  //   props: true,
  //   component: () =>
  //     import(/* webpackChunkName: "page" */ "../views/LandingPage.vue")
  // },

  {
    path: "/:slug",
    name: "page",
    props: true,
    component: () => import(/* webpackChunkName: "page" */ "../views/Page.vue")
  },

  {
    path: "*",
    name: "not-found",
    component: () =>
      import(/* webpackChunkName: "not-found" */ "../views/NotFound.vue")
  }
];

let base_url = "/";
// if (process.env.NODE_ENV === 'production') base_url = '/charleston/';

const router = new VueRouter({
  mode: "history",
  base: base_url,
  routes
});

/**
 * Error: Avoided redundant navigation to current location
 */
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

// router.beforeEach((to, from, next) => {
//     console.log('beforeEach')
// })

// router.afterEach((to, from) => {
//     console.log('afterEach')
// })

export default router;
